// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-error {\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.auth-error h1 {\n  font-size: 2.2rem;\n  font-weight: 600;\n  margin: 0.8rem 0;\n  border: none;\n  line-height: 2.4rem;\n}\n.auth-error h1.error {\n  color: #DE350D;\n}\n.auth-error h1.info {\n  color: #4D2BCC;\n}\n.auth-error p, .auth-error a {\n  color: #888;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.auth-error a {\n  color: #0059ff;\n}", ""]);
// Exports
module.exports = exports;
